import { useFormContext, useWatch } from 'react-hook-form';
import { RECURRENCE_SCHEDULE_TYPES_WITH_SKIP_ON_DAYS } from './Scheduler.constants';
import { RecurrenceScheduleType } from './Scheduler.types';
import { EndRecurrence } from './EndRecurrence';
import { RecurDays } from './RecurDays';
import { Recurrence } from './Recurrence';
import { SkipDaysOfWeek } from './SkipDaysOfWeek';
import { StartDateAndTime } from './StartDateAndTime';

/**
 * Returns whether a user as selected recurring options for scheduling a campaign
 */
const getIsRecurringScheduleType = (recurrence: RecurrenceScheduleType) =>
  recurrence !== RecurrenceScheduleType.DoNotRepeat;

export const SchedulerForm = () => {
  const { getValues } = useFormContext();
  const recurrence = useWatch({
    name: 'recurrence',
    defaultValue: getValues().recurrence,
  });
  const isCustomRecurrenceScheduleSelected = recurrence === RecurrenceScheduleType.Custom;
  const isRecurringScheduleType = getIsRecurringScheduleType(recurrence);
  const isRecurrenceWithSkipOnDaysSelected =
    RECURRENCE_SCHEDULE_TYPES_WITH_SKIP_ON_DAYS.includes(recurrence);

  return (
    <>
      <StartDateAndTime />
      <Recurrence />
      {isCustomRecurrenceScheduleSelected && <RecurDays />}
      {isRecurringScheduleType && <EndRecurrence />}
      {isRecurrenceWithSkipOnDaysSelected && <SkipDaysOfWeek />}
    </>
  );
};
